import ECheckPaymentDetailsTableMobile from './ECheckPaymentDetailsTableMobile';

export default ECheckPaymentDetailsTableMobile;
